export default {
  kw: 'kW',
};



// WEBPACK FOOTER //
// ./js/lang/fr/units.js